import { Link } from "react-router-dom";

const EcomSolutions = () => {
    return (
      <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
    <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                E-com Solutions 
            </h1>
            {/* <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
            No other industry is changing as rapidly and with as much effect as the e-commerce industry. 
            The e-com landscape in Pakistan is at an extremely exciting stage given that it is 
            still exploring and finding its own feet. 
            </p> */}
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              With e-commerce industry in Pakistan booming and gaining momentum at an exciting pace, 
              TCS is leading the way when it comes to bringing everything at the doorstep of customers. 
              When you remove the physical boundaries of a store, you offer a plethora of convenience to your 
              customers, and this is where TCS can become your partner in making customers’ lives convenient and easy.
          </p>
            <div className=" w-[100%]">
                    
                    <div className="mt-[1rem] flex justify-left item-left">
                        <Link to="/ecom-solution" className="flex justify-center text-center items-center h-9 mt-[2px] rounded-sm text-white bg-[#D40511] border border-[#F21E26] w-[10rem] rounded-md mt-[1rem] p-1 h-[2.5rem] text-sm hover:bg-[#F21E26] hover:text-white transition-all duration-500">Find Out More</Link>
                       
                    </div>
            </div>
          
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img src="/DomesticScrollingBanner/image17.jpg" alt="" className="scrolling-image max-w-[100%]"/>
          </div>
        </div>
        

        
      </div>
     
    </div>
    )
};
export default EcomSolutions;